import Vue from 'vue';
import store from './../../store';
import orderProductTransformer from './../../transformers/orderProduct';

const success = ({ data }, resolve) => {
  // DEBUG: raw API response (order products from GET /orders/:id/products)
  console.log('[orderProduct/all] API response (data.data):', data.data);
  console.log('[orderProduct/all] discount per item (raw):', (data.data || []).map(p => ({ id: p.id, product_id: p.product_id, name: p.name, discount: p.discount })));

  const orderProducts = orderProductTransformer.fetchCollection(data.data);

  // DEBUG: after transform (what goes to store / table)
  console.log('[orderProduct/all] transformed orderProducts (discount):', orderProducts.map(p => ({ id: p.id, productId: p.productId, name: p.name, discount: p.discount })));

  store.dispatch('fetchAllOrderProducts', orderProducts);
  resolve(orderProducts);
};

const failed = () => {
};


export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/orders/${id}/products`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderProduct/all.js